import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

require.ensure([], () => {  
    require('./PMO.less');
});

class AttributeButton extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    handleClick = () => {
        this.props.handleClick(this.props.id);
    }

    render = () => {
        return (
            <Button className="pill pill-normal" style={{marginTop : "5px"}} onClick={this.handleClick}>
                <h4 className="clearfix clip-it">
                    <div className="pull-left small-caps left-text-longer">{this.props.text}</div>
                </h4>
            </Button>
        );
    }
}

AttributeButton.propTypes = {
    handleClick: PropTypes.func,
    id: PropTypes.number,
    text: PropTypes.string
};

export default connect()(AttributeButton);


/** WEBPACK FOOTER **
 ** ./src/app/components/AttributeButton.js
 **/